module.exports = __webpack_public_path__ + "img/illustration_mortality.5c200097.svg";